import { render, staticRenderFns } from "./HairLongIs.vue?vue&type=template&id=e77836d4&scoped=true"
import script from "./HairLongIs.vue?vue&type=script&lang=js"
export * from "./HairLongIs.vue?vue&type=script&lang=js"
import style0 from "./HairLongIs.vue?vue&type=style&index=0&id=e77836d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77836d4",
  null
  
)

export default component.exports